<template>
  <div class="FormPrompt">
    <!--
      type: string
      category: string
      name: string
      template: string (text)
      adjustments: (object)
    -->
    <Field
      :label="$t('name')"
      type="text"
      :value.sync="prompt.name" />
    <Field
      :label="$t('category')"
      :options="categoriesOptions"
      type="select"
      :value.sync="prompt.category" />
    <Field
      :label="$t('type')"
      :options="promptTypes"
      type="select"
      :value.sync="prompt.type" />
    <Field
      :label="$t('template')"
      type="textarea"
      :value.sync="prompt.template" />
    <FormAdjustments
      :adjustments.sync="prompt.adjustments" />
  </div>
</template>

<script>
import FormAdjustments from './FormAdjustments'
import { getters } from '@utils'
import { nullOption } from '@utils/state'

export default {
  components: { FormAdjustments },
  props: {
    prompt: Object,
  },
  computed: {
    categoriesOptions() {
      return [
        nullOption(this.$t('allCategories')),
        ...this.categories,
      ]
    },
    ...getters('categories', 'promptTypes'),
  },
}
</script>

<style lang="scss">
.FormPrompt {
}
</style>

<i18n>
{
  "en": {
    "allCategories": "All categories",
    "name": "Name",
    "category": "Category",
    "type": "Type",
    "template": "Template"
  }
}
</i18n>
